<template>
  <div class="device-list__top">
    <div class="top-title__box">
      <div class="icon" :style="{ backgroundColor: iconColor, width: width + 'vw', height: height + 'vh' }"></div>
      <div class="title">{{ title }}</div>
    </div>

    <div class="slot-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 0.4,
    },
    height: {
      type: Number,
      default: 2.6,
    },
  },
  name: 'customHeader',
}
</script>

<style scoped lang="less">
.device-list__top {
  display: flex;
  width: 100%;
  height: 3.3vh;
  align-items: center;
  padding: 0.9vh 0;
  box-sizing: content-box;

  .top-title__box {
    display: flex;
    align-items: center;

    .title {
      font-size: 1vw;
      margin-left: 1vw;
      margin-right: 1vw;
    }
  }

  .slot-box {
    flex: 1;
    display: flex;
  }
}
</style>
